import offerJson from "../../data/plugAndAppDevelopmentOffer.json";

export default function Section4() {
  const offerData = offerJson;

  return (
    <div className="Section4">
      <div className="section4-container">
        <div className="w-[90%] md:w-[61%] m-[24px_20px] md:mx-auto">
          <h2 className="text-center text-[24px] leading-[32px] md:text-[34px] font-bold md:leading-[41px] text-[#151515] my-[0.67em]">
            What We Offer
          </h2>
        </div>

        <div className="flex boxes my-[3%] xl:my-0 p-[2%_0_4%_0] justify-center gap-y-[19px] md:gap-y-[30px] gap-x-[2%] w-full xl:w-[85%] mx-auto flex-wrap">
          {offerData.map(({ title, list }, index) => {
            return (
              <div
                key={index + title}
                className={`box-${index + 1} ${
                  (index + 1) % 2 === 0
                    ? "bg-[#f5f5f5] text-[#373737]"
                    : "bg-[#E42E35] text-white"
                }  p-[10%] md:p-[3%] w-[90%] md:w-[30%] xl:w-[26%] `}
              >
                <h3 className="text-[20px] leading-[24px] xl:text-[25px] capitalize font-bold xl:leading-[30px] pb-[4%] my-[0.67em]">
                  {title}
                </h3>

                {list.map((item, index) => {
                  return (
                    <li
                      key={item + index}
                      className="list-disc text-[12px] md:text-[14px] font-open"
                    >
                      {item}
                    </li>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
